module.exports = __webpack_public_path__ + "img/alarm-record.9b220411.svg";